import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  StyledResultTitle,
  ChangeOfPlans,
  OopsStartOverLink,
  StyledStartOverButton,
} from './resultsStyles';
import Button from './Button';
import Title from './Title';
import Text from './Text';
import { mp } from '../../constants/utils';

const Oops = ({ to, event, onClick }) => (
  <Fragment>
    <Title level={2} styles={StyledResultTitle}>
      Oops! Hubo un error
    </Title>
    <p style={{ marginTop: '5px' }}>Una disculpa, al recibir tu información algo salió mal. </p>
    <ChangeOfPlans>
      <OopsStartOverLink onClick={onClick} to={to}>
        <Button
          styles={StyledStartOverButton}
          onClick={() => {
            mp(event);
          }}
        >
          <Text type="buttonText" color="white" medium>
            Empezar de nuevo
          </Text>
        </Button>
      </OopsStartOverLink>
    </ChangeOfPlans>
  </Fragment>
);

Oops.propTypes = {
  to: PropTypes.string,
  event: PropTypes.string,
  onClick: PropTypes.func,
};

Oops.defaultProps = {
  event: '',
  to: '',
  onClick: () => {},
};

export default Oops;
